import React, { createContext, useState, useEffect } from 'react'
import { personalization_url } from 'utils/js/endpoints'

export const UserContext = createContext({})

export const UserProvider = ({ children }) => {
    const [favourites, setFavourites] = useState({}) // favourites organized by league
    const [isLoadingFavourites, setIsLoadingFavourites] = useState(true)
    const [isRefreshingFavourites, setIsRefreshingFavourites] = useState(false)
    const [favouritesError, setFavouritesError] = useState(false)
    const [user, setUser] = useState({})

    const refreshFavourites = () => {
        setIsRefreshingFavourites(true)
        getFavourites(user.easFlatToken)
            .then(faves => {
                setFavourites(faves)
            })
            .catch(() => {
                setFavourites({})
                setFavouritesError(true)
            })
            .finally(() => setIsRefreshingFavourites(false))
    }

    const getFavourites = async apiToken => {
        const favouritesFromAPI = await fetchFavorites(apiToken)
        const favouritesFromLocalStorage = JSON.parse(localStorage.getItem('favourites')) || []

        let favourites

        if (favouritesFromAPI.success && favouritesFromAPI.guid) {
            favourites = favouritesFromAPI.data
        } else {
            favourites = favouritesFromLocalStorage
        }

        const favouritesByLeague = {}

        for (const favouriteTeam of favourites) {
            const league = favouriteTeam.league_slug?.toLowerCase()

            if (!favouritesByLeague[league]) {
                favouritesByLeague[league] = []
            }

            if (favouriteTeam.taxonomy === 'teams') {
                favouritesByLeague[league].push(favouriteTeam)
            }
        }
        return favouritesByLeague
    }

    const fetchFavorites = async apiToken => {
        const favouritesRequest = await fetch(`${personalization_url}/preferences`, {
            headers: {
                Authorization: `Bearer ${apiToken}`,
            },
        })

        const favouritesResponse = await favouritesRequest.json()

        if (!favouritesResponse.success) {
            return { success: false }
        }
        return { data: favouritesResponse.selected, success: true, guid: favouritesResponse.guid }
    }

    useEffect(() => {
        const init = () => {
            const tokenFromLocalStorage = JSON.parse(localStorage.getItem('easFlatToken'))
                ?.flatToken

            const userDataFromLocalStorage = JSON.parse(localStorage.getItem('cosmosdbData')) || {}
            const easDataFromLocalStorage = JSON.parse(localStorage.getItem('easProfileData')) || {}

            if (tokenFromLocalStorage && easDataFromLocalStorage) {
                const userInitials =
                    Object.keys(userDataFromLocalStorage).length > 0
                        ? `${userDataFromLocalStorage.firstName
                              ?.toUpperCase()
                              .slice(0, 1)}${userDataFromLocalStorage.lastName
                              ?.toUpperCase()
                              .slice(0, 1)}`
                        : easDataFromLocalStorage.email?.toUpperCase().slice(0, 2)

                const userFirstname =
                    Object.keys(userDataFromLocalStorage).length > 0
                        ? `${userDataFromLocalStorage.firstName?.toUpperCase()}`
                        : easDataFromLocalStorage.email?.toUpperCase().slice(0, 2)

                setUser({
                    ...userDataFromLocalStorage,
                    displayName: userInitials,
                    isLoggedIn: !!easDataFromLocalStorage,
                    guid: easDataFromLocalStorage.guid,
                    easFlatToken: tokenFromLocalStorage,
                    firstName: userFirstname,
                })
            }

            getFavourites(tokenFromLocalStorage)
                .then(faves => {
                    setFavourites(faves)
                })
                .catch(() => {
                    setFavouritesError(true)
                    setFavourites({})
                })
                .finally(() => setIsLoadingFavourites(false))
        }

        init()
    }, [])

    return (
        <UserContext.Provider
            value={{
                user,
                favourites,
                refreshFavourites,
                favouritesError,
                isRefreshingFavourites,
                isLoadingFavourites,
            }}
        >
            {children}
        </UserContext.Provider>
    )
}

export default UserContext
